import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.integrationForm`;
export const INIT = `${SCOPE}/INIT`;
export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const UPDATE_CONFIG = `${SCOPE}/UPDATE_CONFIG`;
export const UPDATE_AI_CONFIG = `${SCOPE}/UPDATE_AI_CONFIG`;
export const UPDATE_MANUAL_CONFIG = `${SCOPE}/UPDATE_MANUAL_CONFIG`;
export const CHANGE_CUSTOMISATION_MODAL_VISIBILITY = `${SCOPE}/CHANGE_CUSTOMISATION_MODAL_VISIBILITY`;
export const TOGGLE_ALERT = `${SCOPE}/TOGGLE_ALERT`;
export const SAVE_CONFIG = `${SCOPE}/SAVE_CONFIG`;
export const CREATE_CONFIG = `${SCOPE}/CREATE_CONFIG`;
export const EDIT_CONFIG = `${SCOPE}/EDIT_CONFIG`;
export const VERIFY_CONFIG = `${SCOPE}/VERIFY_CONFIG`;
export const TOGGLE_VERIFY_DIALOG = `${SCOPE}/TOGGLE_VERIFY_DIALOG`;
export const CLEAR_CONFIG = `${SCOPE}/CLEAR_CONFIG`;
